import { PharmacDatePicker, PharmacLabel } from '@pharmac/ui'
import { Control, Controller, FieldValues, Message, ValidationRule } from 'react-hook-form'

type ControllerRules = {
  required?: Message | ValidationRule<boolean>
}

type ControlledDatePickerProps = {
  control?: Control<FieldValues>
  label?: string
  name: string
  placeholder?: string
  rules?: ControllerRules
}

export const ControlledDatePicker = (props: ControlledDatePickerProps) => {
  const isRequired = !!props.rules && !!props.rules.required
  return (
    <>
      {!!props.label && (
        <PharmacLabel marginSmallBottom>
          {props.label} {isRequired && '*'}
        </PharmacLabel>
      )}
      <Controller
        rules={props.rules}
        name={props.name}
        control={props.control}
        render={({ field }) => (
          <PharmacDatePicker
            placeholder={props.placeholder}
            value={field.value}
            onChange={(value) => field.onChange(value)}
          />
        )}
      />
    </>
  )
}
